import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { matchValuePriorities } from '../../util/valuePriorities';

import css from './ValuePriorities.module.css';

/**
 * "Matches 2 of your 3 priorities".
 *
 * A factual count of which of the shopper's chosen ecolabels a product carries.
 * Deliberately not a score or a ranking: it says nothing about one product being
 * better than another, only whether it meets criteria the shopper picked.
 *
 * @component
 * @param {Object} props
 * @param {Array<string>} props.priorities the shopper's priorities (ecolabel keys)
 * @param {Array<string>} props.ecolabelKeys the ecolabels the product has been awarded
 * @param {boolean} [props.showNoMatch] say so when none match (product page); cards stay quiet
 * @param {string} [props.className]
 * @returns {JSX.Element|null} null when the shopper hasn't set any priorities
 */
const ValuePrioritiesMatch = props => {
  const { priorities = [], ecolabelKeys = [], showNoMatch = false, className } = props;
  const { matched, total } = matchValuePriorities(priorities, ecolabelKeys);

  if (total === 0 || (matched.length === 0 && !showNoMatch)) {
    return null;
  }

  const messageId =
    matched.length === 0
      ? 'ValuePriorities.matchNone'
      : matched.length === total
      ? 'ValuePriorities.matchAll'
      : 'ValuePriorities.matchSome';

  return (
    <p
      className={classNames(css.match, className, {
        [css.matchNone]: matched.length === 0,
      })}
    >
      <FormattedMessage id={messageId} values={{ matched: matched.length, total }} />
    </p>
  );
};

export default ValuePrioritiesMatch;
